import { observable, runInAction } from 'mobx';
import ErrorUtil from '../error/ErrorUtil';
import API from '../util/ApiUtil';
import { FetchStatus } from '../util/FetchStatus';

export interface Ms365Price {
  price: number;
  isDiscount: boolean;
  discountPrice: number;
  discountEndDate: string;
}

class Ms365Store {
  @observable accessor prices: Map<string, Ms365Price> = new Map<string, Ms365Price>();
  @observable accessor status: FetchStatus = FetchStatus.UNINITIALIZED;

  public async fetchPrices() {
    try {
      runInAction(() => {
        this.status = FetchStatus.FETCHING;
      });
      const response = await API.get('microsoft365/prices');
      runInAction(() => {
        this.prices = new Map(Object.entries(response?.data?.prices));
        this.status = FetchStatus.FETCHED;
      });
    } catch (e) {
      runInAction(() => {
        this.status = FetchStatus.ERROR;
      });
      ErrorUtil.pushErrorToTeliaRumAndLog(e);
    }
  }
}

export default Ms365Store;
